export enum EditorialStatusEnum {
  HOME = 'HOME',
  DEUS_CONOSCO = 'DEUS_CONOSCO',
  FAMILIA_DOS_DEVOTOS = 'FAMILIA_DOS_DEVOTOS',
  APARECIDA_PLAY = 'APARECIDA_PLAY',
}
